var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "235px",
    height: "125px",
    viewBox: "0 0 235 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "80F4C29E-FC5B-4A18-94CA-52B6BCA334E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 235,
    height: 125,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat-Simplified-Widget---Style-Guide",
    transform: "translate(-378.000000, -479.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EEEEEE",
    x: 0,
    y: 0,
    width: 1463,
    height: 2535
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget/Data/Chat/Summary-Metrics-Copy-3",
    transform: "translate(378.000000, 479.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 235,
    height: 125
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#999999",
    x: 7,
    y: 11,
    width: 189,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#999999",
    x: 49,
    y: 44,
    width: 119,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#999999",
    x: 49,
    y: 85,
    width: 91,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#999999",
    x: 49,
    y: 60,
    width: 102,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#999999",
    x: 49,
    y: 101,
    width: 87,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FDE896",
    x: 7,
    y: 42.2266436,
    width: 29,
    height: 29,
    rx: 14.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#66CCBB",
    x: 7,
    y: 83.2266436,
    width: 29,
    height: 29,
    rx: 14.5
  }), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 23,
    fontWeight: 400,
    fill: "#485159"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 64.2266436
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: 2,
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 23,
    fontWeight: 400,
    fill: "#485159"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 15,
    y: 105.226644
  }, "2")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFive);
export default __webpack_public_path__ + "static/media/top-five.8439f0e503f213af6791f08adf971301.svg";
export { ForwardRef as ReactComponent };